// extracted by mini-css-extract-plugin
module.exports = {"styledModalRoot":"yOt0HkID","customSelectorWrapper":"n6VZUd41","modalTitleWrapper":"MkWpW5Gk","customStyledInputWrapper":"N7H4n0Wk"};